import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import { usePostHog } from 'posthog-js/react'

export const usePosthogIdentify = (): void => {
  const posthog = usePostHog()
  const { user } = useUser()

  useEffect(() => {
    if (user && posthog) {
      posthog.identify(user.externalId ?? undefined, {
        username: (user.publicMetadata as any).username,
        clerk_id: user.id,
        has_glasspass: (user.publicMetadata as any).has_glasspass,
        glasspass_type: (user.publicMetadata as any).glasspass_type,
        accepts_marketing: (user.publicMetadata as any).accepts_marketing,
        is_staff: (user.publicMetadata as any).is_staff,
        created_at: user.createdAt?.toISOString()
      })
    }
  }, [user, posthog])
}
